import { Injectable } from '@angular/core';
import { Subject, Observable, of} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PublicConfigStore {
    private _data: any | null;
    private _ready: Subject<any> = new Subject();

    public setData(data: any) {
        this._data = data;
        this._ready.next(data);
        this._ready.complete();
    }

    public getData(): Observable<any> {
        if (this._data) {
            return of(this._data);
        }
        return this._ready;
    }
}
